import { Box } from '@mui/material';
import React from 'react';

import { styles } from './ColumnPlaceholderText.styles';

export function ColumnPlaceholderText() {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.xs} />
      <Box sx={styles.md} />
      <Box sx={styles.xl} />
      <Box sx={styles.lg} />
      <Box sx={styles.sm} />
      <Box sx={styles.sm} />
      <Box sx={styles.md} />
      <Box sx={styles.xl} />
      <Box sx={styles.xs} />
      <Box sx={styles.xs} />
      <Box sx={styles.md} />
      <Box sx={styles.xs} />
      <Box sx={styles.sm} />
      <Box sx={styles.md} />
      <Box sx={styles.lg} />
    </Box>
  );
}
